import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { HelpersService } from './services/helpers.service';


@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit {


  constructor(private helpersService: HelpersService, translate: TranslateService, private cdr: ChangeDetectorRef) {
    translate.addLangs(['en', 'it']);
    translate.setDefaultLang(this.helpersService.DEFAULT_LANG);
    if (environment.translate) {
      if (helpersService.lang && helpersService.lang.toLowerCase().match(/it|en/)) {
        translate.use(helpersService.lang);
      } else {
        translate.use(this.helpersService.DEFAULT_LANG);
      }
    } else {
      translate.use(this.helpersService.DEFAULT_LANG);
    }
  }

  ngOnInit(): void {
    let intervalCdr = setInterval(()=>{
      this.cdr.detectChanges();
    },500)
  }

}